/**
 * Le lot Ma dispo et offres de cours : ses routes poussées et son onglet (« Offres de cours »).
 *
 * Chaque écran est chargé à son premier rendu (`loadedOnRender`, comme chez l'élève : le registre ne
 * charge aucun écran en tête). Aucune entrée ne vit en live : dans la salle, ces routes gardent leur
 * ancien écran.
 */
import { loadedOnRender } from "../../student/loadedOnRender"
import { type TutorSpaceRouteTable, type TutorSpaceTabTable } from "../tutorSpaceRouteTypes"

/* eslint-disable @typescript-eslint/no-require-imports */
export const availabilityRoutes: TutorSpaceRouteTable<"availability"> = {
    "tutor/ma-dispo": loadedOnRender(
        () => require("./TutorAvailabilityScreen").TutorAvailabilityScreen,
        "TutorAvailabilityScreen"
    ),
    "tutor/liberer-creneaux": loadedOnRender(
        () => require("./TutorReleaseSlotsScreen").TutorReleaseSlotsScreen,
        "TutorReleaseSlotsScreen"
    ),
    "group-attribution-proposals": loadedOnRender(
        () => require("./TutorOfferScreen").TutorGroupOfferScreen,
        "TutorGroupOfferScreen"
    ),
    "substitution-proposals": loadedOnRender(
        () => require("./TutorOfferScreen").TutorSubstitutionOfferScreen,
        "TutorSubstitutionOfferScreen"
    ),
}

export const availabilityTabs: TutorSpaceTabTable<"availability"> = {
    proposals: loadedOnRender(() => require("./TutorOffersScreen").TutorOffersScreen, "TutorOffersScreen"),
}
/* eslint-enable @typescript-eslint/no-require-imports */
